import { useMemo } from 'react'
import useActivePersonsOfUser from 'hooks/useActivePersonsOfUser'
import useListCmsPaginatedContents from 'hooks/useListCmsPaginatedContents'
import { useAbsenceRequestContext } from 'redesign/services/absence-request/use-absence-request-context'
import { ZERO } from 'shared/constants'
import { CONTENT_TYPES } from 'types/cms'
import { getDatetimeRangeWithTimezone } from 'utils/date'
import type { NewAbsenceRequestEventAlertProps } from './types'

const useNewAbsenceRequestAlerts = ({ startDate, endDate, selectedPersonUuid }: NewAbsenceRequestEventAlertProps) => {
  const { showAbsencePlannerDrawer, setShowAbsencePlannerDrawer } = useAbsenceRequestContext()
  const validDates = startDate && endDate
  const eventsDateRange = useMemo(
    () => (validDates ? getDatetimeRangeWithTimezone({ start: startDate, end: endDate }) : undefined),
    [endDate, startDate, validDates],
  )
  const { list: listOfRestrictingEvents, loading } = useListCmsPaginatedContents({
    skip: !validDates,
    contentType: CONTENT_TYPES.event,
    ...eventsDateRange,
    isAbsenceRestricted: true,
    showAdmin: false,
  })

  const { persons } = useActivePersonsOfUser()

  const selectedPerson = useMemo(
    () => (persons ?? []).find(({ favurUuid }) => selectedPersonUuid === favurUuid),
    [persons, selectedPersonUuid],
  )

  const showRestrictingEvents = useMemo(
    () => !loading && listOfRestrictingEvents.length > ZERO,
    [listOfRestrictingEvents.length, loading],
  )
  const showConflictsCard = useMemo(
    () => !loading && listOfRestrictingEvents.length === ZERO,
    [listOfRestrictingEvents.length, loading],
  )

  return {
    validDates,
    showRestrictingEvents,
    showConflictsCard,
    selectedPerson,
    listOfRestrictingEvents,
    showAbsencePlannerDrawer,
    setShowAbsencePlannerDrawer,
  }
}

export default useNewAbsenceRequestAlerts
